import fetch from './fetch';
/**
 * 获取token信息
 * @method loginByEmail
 */
export function loginByEmail(obj) {
    return fetch({
      url: '/api/auth/jwt/token',
      method: 'post',
      data: obj
    });
  }
  /**
   * 获取全部订单
   * @method listOrder
   */
  export function listOrder(query) {
    return fetch({
      url: '/api/app/miniApp/listOrder',
      method: 'get',
      params: query
    });
  }
/**
 * 获取订单详情
 * @method getOrderDetail
 */
export function getOrderDetail(query) {
  return fetch({
    url: '/api/app/miniApp/getOrderDetail',
    method: 'get',
    params: query
  });
}
/**
 * 获取保修列表
 * @method listQuestionnaire
 */
export function listQuestionnaire(query) {
  return fetch({
    url: '/api/app/miniApp/listQuestionnaire',
    method: 'get',
    params: query
  });
}
/**
 * 获取预算列表
 * @method listOrderBudget
 */
export function listOrderBudget(query) {
  return fetch({
    url: '/api/app/miniApp/listOrderBudget',
    method: 'get',
    params: query
  });
}
/**
 * 获取预算详情
 * @method listOrderBudgetDetail
 */
export function listOrderBudgetDetail(query) {
  return fetch({
    url: '/api/app/miniApp/listOrderBudgetDetail',
    method: 'get',
    params: query
  });
}
/**
 * 新增报修申请
 * @method addQuestionnaire
 */
export function addQuestionnaire(obj) {
  return fetch({
    url: '/api/app/miniApp/addQuestionnaire',
    method: 'post',
    data: obj
  });
}
/**
 * 获取合同列表
 * @method listOrderContract
 */
export function listOrderContract(query) {
  return fetch({
    url: '/api/app/miniApp/listOrderContract',
    method: 'get',
    params: query
  });
}


/**
 * 选择套餐列表
 * @method listOrderByPackage
 */
export function listOrderByPackage(query) {
  return fetch({
    url: '/api/app/expenditure/package/listOrderByPackage',
    method: 'get',
    params: query
  });
}

export function listStoreExpenditure(query) {
  return fetch({
    url: '/api/app/expenditure/package/listStoreExpenditure',
    method: 'get',
    params: query
  });
}



export function checkIsCollected(query) {
  return fetch({
    url: '/api/app/expenditure/package/checkIsCollected',
    method: 'get',
    params: query
  });
}



/**
 * 获取我的收据
 * @method listElectronicReceipt
 */
export function listElectronicReceipt(query) {
  return fetch({
    url: '/api/app/miniApp/listElectronicReceipt',
    method: 'get',
    params: query
  });
}


/**
 * 获取预约列表
 * @method listActivityAppointment
 */
export function listActivityAppointment(query) {
  return fetch({
    url: '/api/app/miniApp/listActivityAppointment',
    method: 'get',
    params: query
  });
}
/**
 * 手机号验证
 * @method sendSms
 */
export function sendSms(query) {
  return fetch({
    url: '/api/app/miniApp/sendSms',
    method: 'get',
    params: query
  });
}
/**
 * 获取用户信息
 * @method getCustomerInfo
 */
export function getCustomerInfo(query) {
  return fetch({
    url: '/api/app/miniApp/getCustomerInfo',
    method: 'get',
    params: query
  });
}

/**
 * 登录
 * @param query
 * @returns {AxiosPromise}
 */
export function customerLogin(query) {
    return fetch({
        url: '/api/app/miniApp/customerLogin',
        method: 'get',
        params: query
    });
}
/**
 * 活动列表
 * @method listActivity
 */
export function listActivity(query) {
  return fetch({
    url: '/api/app/miniApp/listActivity',
    method: 'get',
    params: query
  });
}
/**
 * 活动详情
 * @method getActivityDetail
 */
export function getActivityDetail(query) {
  return fetch({
    url: '/api/app/miniApp/getActivityDetail',
    method: 'get',
    params: query
  });
}
/**
 * 签订合同
 * @method getActivityDetail
 */
export function signContract(obj) {
  return fetch({
    url: '/api/app/miniApp/signContract',
    method: 'put',
    data: obj
  });
}

/**
 * 签订合同-- 瓷砖
 * @method getActivityDetail
 */
export function signContractOfTile(obj) {
  return fetch({
    url: '/api/app/miniApp/signContractOfTile',
    method: 'put',
    data: obj
  });
}

/**
 * 签字服务单
 * @method signServiceBillPDF
 */
export function signServiceBillPDF(obj) {
  return fetch({
    url: '/api/app/serviceBill/signServiceBillPDF',
    method: 'post',
    data: obj
  });
}


/**
 * 字典
 * @method listBaseDict
 */
export function listBaseDict(query) {
  return fetch({
    url: '/api/pc/common/listBaseDict',
    method: 'get',
    params: query
  });
}
/**
 * 获取编号
 * @param query
 * serialNumber
 */
export function getUUID(query) {
  return fetch({
    url: '/api/pc/common/getUUID',
    method: 'get',
    params: query
  });
}
/**
 * 签订合同
 * @method addInvoice
 */
export function addInvoice(obj) {
  return fetch({
    url: '/api/app/miniApp/addInvoice',
    method: 'post',
    data: obj
  });
}
/**
 * 获取二维码
 * @method create
 */
export function creates(obj) {
  return fetch({
    url: '/wx/cgi-bin/qrcode/create',
    method: 'post',
    data: obj
  });
}
/**
 * 获取门店列表
 * @method listStore
 */
export function listStore(query) {
  return fetch({
    url: '/api/app/miniApp/listStore',
    method: 'GET',
    params: query
  });
}
/**
 * 获取微信jsdk时间戳
 * @method listStore
 */
export function getWxJsTicket(query) {
  return fetch({
    url: '/api/app/miniApp/getWxJsTicket',
    method: 'GET',
    params: query
  });
}
/**
 * 获取私人顾问
 * @method listStore
 */
export function listOrderContacts(query) {
  return fetch({
    url: '/api/app/miniApp/listOrderContacts',
    method: 'GET',
    params: query
  });
}
/**
 * 获取支付二维码
 * 
 */
export function getCollectCodeAccount(query) {
  return fetch({
    url: '/api/app/expenditure/package/getCollectCodeAccount',
    method: 'GET',
    params: query
  });
}


/**
 * 获取签名
 * @method listStore
 */
export function getWxJsSignature(query) {
  return fetch({
    url: '/api/app/miniApp/getWxJsSignature',
    method: 'GET',
    params: query
  });
}
/**
 * 获取品牌列表
 * @method listBrand
 */
export function listBrand() {
  return fetch({
    url: '/api/app/common/listBrand',
    method: 'get'
  });
}
/**
 * 获取品类列表
 * @method listCategory
 */
export function listCategory() {
  return fetch({
    url: '/api/app/common/listCategory',
    method: 'get'
  });
}
/**
 * 新增0原设计
 * @method addActivityAppointment
 */
export function addActivityAppointment(obj) {
  return fetch({
    url: '/api/app/miniApp/addActivityAppointment',
    method: 'post',
    data: obj
  });
}


export function addStoreExpenditure(obj) {
  return fetch({
    url: '/api/app/expenditure/package/addStoreExpenditure',
    method: 'post',
    data: obj
  });
}


/**
 * 获取方案服务单
 * @method listServiceBill
 */
export function listServiceBill(query) {
  return fetch({
    url: '/api/app/serviceBill/listServiceBill',
    method: 'get',
    params: query
  });
}

/**
 * 获取方案服务单pdf
 * @method getServiceBillPDF
 */
export function getServiceBillPDF(query) {
  return fetch({
    url: '/api/app/serviceBill/getServiceBillPDF',
    method: 'get',
    params: query
  });
}





